<template>
  <div :class="lotClass">
    <div
      :style="{ fontSize: proportions > 1.1 ? `${1.2 / proportions}em` : '1em' }"
      class="lot__inner"
    >
      <template v-if="auction">
        <div
          :style="lotBgStyle"
          class="lot__bg"
        />

        <div class="lot__content">
          <div class="lot__timer">
            <timer-icon/>
            {{ display }}
          </div>
          <div class="lot__title">
            <template v-if="true">
              <div class="lot__title__model">
                <b>{{ auction.brand }}</b>
                <span>{{ auction.model }}</span>
                <span>{{ auction.year }}</span>
              </div>
              <div class="lot__title__id">
                #{{ auction.appointmentId }}
              </div>
            </template>
            <template v-else>終了</template>
          </div>
          <div class="lot__price">¥{{ amount(auction.fullPrice) }}</div>
        </div>

        <div class="lot__bids">
          <div>入札数</div>
          <b>{{ bidsCount || 0 }}</b>
        </div>

        <div class="lot__overlay"/>
        <div class="lot__bid">
          <div>入札</div>
          <div class="lot__bid__diff">+¥{{ amount(diff) }}</div>
        </div>

        <auction-meter
          :value="auction.sellingPriceMeter"
          :stopped="isFinished || auction.isFinished()"
        />
      </template>
      <template v-else>
        <div class="lot__content">
          <div class="lot__timer">
            <timer-icon/> -
          </div>
          <div class="lot__title">オークション準備中</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AuctionMixin from './mixins/AuctionMixin';
import AuctionMeter from './elements/Meter';
import TimerIcon from './elements/TimerIcon';

export default {
  components: {
    AuctionMeter,
    TimerIcon,
  },
  mixins: [
    AuctionMixin,
  ],
  props: {
    auction: {
      type: Object,
      default: null,
    },
    proportions: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      diff: 0,
      newBid: false,
      newBidTimeout: null,
    };
  },
  computed: {
    bestBidPrice() {
      return this.auction ? this.auction.bestBidPrice : 0;
    },
    fullPrice() {
      return this.auction ? this.auction.fullPrice : 0;
    },
    bidsCount() {
      return this.auction.bidsCount > 0 ? this.auction.bidsCount - 1 : 0;
    },
    display() {
      return this.isFinished ? '-' : this.countdown;
    },
    lotClass() {
      return {
        lot: true,
        'lot--empty': !this.auction || (!this.auction.isActive() && !this.auction.isFinished()),
        'lot--new': !!this.auction && this.auction.isNew,
        'lot--old': !!this.auction && this.auction.isOld,
        'lot--bidding': this.newBid,
        'lot--finished': this.isFinished || this.auction.isFinished(),
        'lot--finishing': this.isFinishing && this.auction.isActive(),
      };
    },
    finished() {
      return this.isFinished;
    },
    running() {
      return !!this.action;
    },
    lotBgStyle() {
      return {
        backgroundImage: this.auction && this.auction.carPhoto ? (`url(${this.auction.carPhoto})`) : '',
      };
    },
  },
  watch: {
    fullPrice(to, from) {
      this.newBid = true;
      setTimeout(() => { this.newBid = false; }, 700);

      this.diff = to > from ? to - from : 0;
    },
    finished(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.message('finished');
      }
    },
    running(newVal, oldVal) {
      if (!oldVal && newVal && !this.watchingMsgSent) {
        this.message('watching');
      }
    },
  },
  mounted() {
    if (this.auction && this.auction.isActive) {
      this.message('watching');
      this.watchingMsgSent = true;
    }
  },
  methods: {
    message(message) {
      if (!window.parent) {
        return;
      }
      window.parent.postMessage(message, '*');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Lot.vue